import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";
import { login } from "../Reducer/authReducer";
import { DEFAULTIMAGEURL, IMAGEURL } from "../Utils/EndPoint";
import { UpdateProfile } from "../Reducer/apiCall";
import { setError } from "../Reducer/chatReducer";

const Profile = () => {
    const navigate = useNavigate();
    const [imagePreview, setImagePreview] = useState(null);
    const user = useSelector((state) => state.Auth.user);
    const dispatch = useDispatch();
    const handleClose = () => {
        navigate("/");
        dispatch(setError(null))

    }

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImagePreview(URL.createObjectURL(file));
            formik.setFieldValue("image", file);
        } else {
            setImagePreview(null);
            formik.setFieldValue("image", null);
        }
    };
    const validationSchema = Yup.object({
        firstName: Yup.string().required("First Name is required."),
        lastName: Yup.string().required("Last Name is required."),
        email: Yup.string().email("Invalid email address.").required("Email is required."),
        mobile: Yup.string().required("Mobile number is required."),
        image: Yup.mixed().required("Profile image is required."),
    });

    const formik = useFormik({
        initialValues: {
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.email,
            mobile: String(user.mobile) || "",
            image: user.image,
        },
        validationSchema,
        onSubmit: async (values) => {
            const formData = new FormData();
            formData.append("firstName", values.firstName);
            formData.append("lastName", values.lastName);
            formData.append("email", values.email);
            formData.append("mobile", values.mobile);

            if (values.image?.name) {
                formData.append("image", values.image);
            }
            try {
                const res = await dispatch(UpdateProfile(user._id, formData));
                if (res?.status === 200) {
                    toast.success(res.data.message);
                    dispatch(login(res.data.data));
                    navigate("/login");
                } else {
                    const errorMessage = res?.response?.data?.message || res?.message || "An unknown error occurred.";
                    toast.error(errorMessage);
                }
            } catch (error) {
                toast.error("An unexpected error occurred.");
            }
        },

    });

    return (
        <div className="flex flex-col items-center  text-white min-h-[80vh]">
            <div className="p-6 w-[80%] sm:w-[60%] md:w-[50%] lg:w-[70%] border border-slate-400 bg-slate-800 rounded-lg h-fit mt-1 transition-all">
                <h2 className="text-2xl underline underline-offset-8 font-semibold text-center mb-4">Profile</h2>

                <div className="flex relative justify-center">
                    <img
                        src={
                            imagePreview ||
                            (formik.values.image
                                ? `${IMAGEURL}/${formik.values.image}`
                                : DEFAULTIMAGEURL)
                        }
                        alt="Profile"
                        className="items-center  w-32 h-32 rounded-full border-2 border-slate-400 object-cover"
                    />
                    <label className="absolute top-[35%] cursor-pointer px-4 py-2 bg-slate-700 text-white rounded-full hover:bg-slate-800 transition-all">
                        <FaEdit
                            className="text-white cursor-pointer hover:text-gray-700"
                            size={20} />
                        <input
                            type="file"
                            accept="image/*"
                            className="hidden"
                            onChange={handleImageUpload}
                        />
                    </label>
                    {formik.errors.image && formik.touched.image && (
                        <span className="text-red-500 text-sm">{formik.errors.image}</span>
                    )}
                </div>

                <form onSubmit={formik.handleSubmit} className="flex flex-col gap-4">

                    <div className="flex gap-4">
                        <div className="flex-1">
                            <label className="text-xl font-semibold p-1 block">First Name</label>
                            <input
                                className="w-full border border-slate-700 py-3 px-4 rounded-full bg-white text-black"
                                type="text"
                                placeholder="Enter First Name"
                                name="firstName"
                                value={formik.values.firstName}
                                onChange={formik.handleChange}
                            />
                            {formik.errors.firstName && formik.touched.firstName && (
                                <span className="text-red-500 text-sm">{formik.errors.firstName}</span>
                            )}
                        </div>
                        <div className="flex-1">
                            <label className="text-xl font-semibold p-1 block">Last Name</label>
                            <input
                                className="w-full border border-slate-700 py-3 px-4 rounded-full bg-white text-black"
                                type="text"
                                placeholder="Enter Last Name"
                                name="lastName"
                                value={formik.values.lastName}
                                onChange={formik.handleChange}
                            />
                            {formik.errors.lastName && formik.touched.lastName && (
                                <span className="text-red-500 text-sm">{formik.errors.lastName}</span>
                            )}
                        </div>
                    </div>

                    <div className="flex gap-4">
                        <div className="flex-1">
                            <label className="text-xl font-semibold p-1 block">Email</label>
                            <input
                                className="w-full border border-slate-700 py-3 px-4 rounded-full bg-white text-black"
                                type="email"
                                placeholder="Enter Email"
                                name="email"
                                value={formik.values.email}
                                onChange={formik.handleChange}
                            />
                            {formik.errors.email && formik.touched.email && (
                                <span className="text-red-500 text-sm">{formik.errors.email}</span>
                            )}
                        </div>
                        <div className="flex-1">
                            <label className="text-xl font-semibold p-1 block">Mobile No</label>
                            <PhoneInput
                                country={"in"}
                                value={formik.values.mobile}
                                onChange={(value) => formik.setFieldValue("mobile", value)}
                                inputClass="w-full py-3 rounded-full bg-white text-black"

                            />
                            {formik.errors.mobile && formik.touched.mobile && (
                                <span className="text-red-500 text-sm">{formik.errors.mobile}</span>
                            )}
                        </div>
                    </div>
                    <div className="flex gap-2 justify-center">

                        <button
                            type="submit"
                            className="font-semibold bg-black rounded-full px-5 py-4 mt-2 text-lg border border-slate-400 text-white hover:bg-slate-700 transition-all"
                        >
                            Update
                        </button>
                        <button
                            type="button"
                            onClick={() => handleClose()}
                            className="font-semibold bg-black rounded-full px-5 py-4 mt-2 text-lg border border-slate-400 text-white hover:bg-slate-700 transition-all"
                        >
                            Close
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Profile;
